(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CampaignSettingsController', campaignSettingsController);

  campaignSettingsController.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'CompanyService', 'NotificationService'];

  function campaignSettingsController ($http, $state, AuthenticationService, $rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.campaignSettings');

    var vmCampaignCtrl = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmCampaignCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmCampaignCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmCampaignCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
